export const CREATE_CATEGORY_REQUEST = 'category/CREATE_REQUEST';
export const CREATE_CATEGORY_SUCCESS = 'category/CREATE_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'category/CREATE_FAILURE';

export function createCategory(category = {}) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: CREATE_CATEGORY_REQUEST,
    });

    const promise = request.post(`/_api/categories/`, category);

    return promise
      .then(category =>
        dispatch({
          type: CREATE_CATEGORY_SUCCESS,
          payload: category,
        })
      )
      .catch(() =>
        dispatch({
          type: CREATE_CATEGORY_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/create-category.js